import { useEffect, useState } from "react";
import { getUserProfile } from "../services/api";

let cachedCompany = null;
let fetchPromise = null;

export function useEmployerCompany() {
  const [company, setCompany] = useState(cachedCompany);
  const [loading, setLoading] = useState(!cachedCompany);

  useEffect(() => {
    if (cachedCompany) {
      setCompany(cachedCompany);
      setLoading(false);
      return undefined;
    }

    if (!fetchPromise) {
      fetchPromise = getUserProfile()
        .then((response) => {
          const profile = response.data?.data;
          cachedCompany = profile?.company || null;
          return cachedCompany;
        })
        .catch(() => {
          cachedCompany = null;
          return null;
        })
        .finally(() => {
          fetchPromise = null;
        });
    }

    fetchPromise.then((result) => {
      setCompany(result);
      setLoading(false);
    });

    return undefined;
  }, []);

  return {
    company,
    loading,
    companyName: company?.company_name || "",
    companyLogo: company?.company_logo || null,
  };
}

export function clearEmployerCompanyCache() {
  cachedCompany = null;
  fetchPromise = null;
}
